import axios from "@/repositories/client";

axios.saveMedia = (id, type, data) => {
  if (!data.images && !data.files) return;
  return axios.request({
    method: 'post',
    url: `athena/v1/media/${type}/${id}`,
    data: data
  })
    .then(response => {
      return response.data;
    });
};

axios.deleteMedia = (id, type, data) => {
  return axios.delete(`athena/v1/media/${type}/${id}/${data.id}`)
    .then(response => {
      return response.data;
    });
};

export default axios;